export const darkenRgbaCssColor = (cssColor: string, factor: number) => {
	const regex = /^rgba?\((\d+), ?(\d+), ?(\d+)(?:, ?(\d+))?\)$/i
	const match = regex.exec(cssColor)

	if (match === null) {
		throw new Error('Invalid color format')
	}

	const r = parseInt(match[1], 10) * factor
	const g = parseInt(match[2], 10) * factor
	const b = parseInt(match[3], 10) * factor
	const a = parseInt(match[4] ?? '255', 10) * factor

	return `rgb(${r}, ${g}, ${b}, ${a})`
}
